
Number.prototype.toMoney = function() {
    // The 1e-10 is here because in a few cases 5s are rounding down without it.
    // For example Math.round(4.475 * 100) / 100 => 4.47
    return (Math.round(this * 100 + 1e-10) / 100).toFixed(2);
};

String.prototype.toMoney = function() {
    return Number( this ).toMoney();
};

if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

var creditCardTypes = {
    '': {
        'label': '',
        'logo': '',
        'watermark': ''
    },
    'amex': {
        'label': 'American Express',
        'logo': 'American Express',
        'watermark': 'Amex'
    },
    'visa': {
        'label': 'Visa',
        'logo': 'Visa<sup>&reg;</sup>',
        'watermark': 'Visa'
    },
    'mastercard': {
        'label': 'MasterCard',
        'logo': 'Mastercard <sup>&reg;</sup>',
        'watermark': '<div></div><div></div>'
    },
    'discover': {
        'label': 'Discover',
        'logo': 'Discover<sup>&reg;</sup>',
        'watermark': ''
    },
    'jcb': {
        'label': "JCB",
        'logo': "JCB",
        'watermark': "",
    },
    'maestro': {
        'label': "Maestro",
        'logo': "Maestro",
        'watermark': "",
    },
};

var seenSuggestions = false;

var suggestionItemHeights = function(){
	$('.pricing').removeClass('shown');
	eqHeights.set({
		selector: '.checkoutpage .pricing'
	}, function(){
		eqHeights.set({
			selector: '.checkoutpage .product-container'
		}, function(){
			$('.pricing').addClass('shown');
		});
	});
};

var validateEmailCart = function(emailCart){
	var $targetEmail = emailCart.find("#targetEmail"),
		noTargetEmail = ! $targetEmail.val().trim(),
        $recaptchaTokenInput = $( ".js-email-cart .js-email-cart-recaptcha-token" ),
		noCaptchaResponse = ! $recaptchaTokenInput.val().trim()

	$targetEmail.toggleClass("field-error", noTargetEmail);

	if(noTargetEmail) {
		return "Missing email address.";
	}

	var caClicked = emailCart.find("#ca:checked").length;
	if ( caClicked == 1 ) {
		var $targetPassword = emailCart.find("#targetPassword");
		var noTargetPassword = ! $targetPassword.val().trim();
		$targetPassword.toggleClass("field-error", noTargetPassword);
		var $targetZip = emailCart.find("#targetZip");
		var noTargetZip = ! $targetZip.val().trim();
		$targetZip.toggleClass("field-error", noTargetZip);

		if ( noTargetPassword )
			return "Missing password.";
		if ( noTargetZip )
			return "Missing zip code.";
	}
	if(noCaptchaResponse) {
		return "Please check I'm not a robot.";
	}
}

var commaSeparate = function (num) {
	var number = parseFloat(num);
	return number.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}

$('.showEmailCart').click(function(){checkout.cart.showEmailCart()});


  Jemplate.Filter.prototype.filters.format = function(text, args) {
    var fmt = args[0];
    if (! text) return null;
    if (typeof fmt == 'undefined')
        fmt = '%.2f';

    var output = sprintf( fmt, text );
    return output;
  };
